<script>
import { loader } from "@/common/mixins/mix_loader";
import { alert } from "@/common/mixins/mix_helper";
import AppConfig from "@/common/config/app.config.json";

export default {
  name: "upload_file",
  mixins: [alert, loader],
  props: {
    file: {
      required: false,
    },
  },
  methods: {
    /**
     * --------------------------------------------------------------
     * ketika memilih file validasi ekstensi
     * --------------------------------------------------------------
     */
    onChooseFile: function (e, paste = false) {
      let attachment = paste ? e : e.target.files[0];

      let extFiles = AppConfig.ext_allowed.file;
      let extImages = AppConfig.ext_allowed.image;
      let allowedExt = [...extFiles, ...extImages];
      if (allowedExt.includes(attachment.type)) {
        let size = Math.round(attachment.size / 1024);
        if (size > 10240) {
          this.$swal({
            title: "Error",
            html: `Ukuran file maksimal 10MB!`,
            icon: "error",
          });
        } else {
          this.loading();
          this.$store
            .dispatch("customerSendMessageFile", {
              tipe: extImages.includes(attachment.type) ? "image" : "file",
              message: attachment,
            })
            .then(({ data }) => {
              if (typeof data.data.token !== "undefined") {
                localStorage.setItem(
                  AppConfig.rwStorage.customer.token,
                  data.data.token
                );
              }
              this.$swal("Success", "Attachment terkirim", "success");
            })
            .catch((error) => {
              if (typeof error.response.data.message !== "undefined") {
                this.$swal("ERROR", error.response.data.message, "error");
              } else {
                this.$swal(
                  "ERROR",
                  `sistem kami gagal mengirim file Anda, silahkan ulangi beberapa saat lagi, atau hubungi kami ke <a href="mailto:info@rumahweb.com">info@rumahweb.com</a> untuk melaporkan masalah ini.`,
                  "error"
                );
              }
            })
            .finally(() => {
              this.loading(false);
            });
        }
      } else {
        // alert when fail
        let ext = attachment.type.split("/");
        ext = ext[1].split("."); // get last ext
        this.$swal({
          title: "Error",
          html: `<b>${ext[ext.length - 1]}</b> tidak diizinkan! <br> \
	  			<small><b>PNG | JPEG | JPG | GIF | BMP | PDF</b></small>`,
          icon: "error",
        });
      }
    },
  },
  watch: {
    file(e) {
      this.onChooseFile(e[0], true);
    },
  },
};
</script>

<template>
  <div
    class="flex justify-center items-center relative bg-gray-200 border-gray-600 hover:bg-gray-400 hover:text-white rounded p-1 cursor-pointer"
    v-b-tooltip.hover
    title="Upload File"
  >
    <input
      type="file"
      @change="onChooseFile"
      ref="file"
      class="absolute w-full opacity-0 cursor-pointer"
    />
    <span class="material-symbols-outlined" style="font-size: 16px"
      >attach_file_add</span
    >
  </div>
</template>

<style scoped></style>
